const state = {
  token: localStorage.getItem('token') || '',
  userInfo: {
    name: '管理员',
    avatar: ''
  }
}

const mutations = {
  SET_TOKEN(state, token) {
    state.token = token
    localStorage.setItem('token', token)
  },
  SET_USER_INFO(state, info) {
    state.userInfo = info
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
